'use client';

import React from 'react';
import { useBodyClassName } from '@/utils/hooks/useBodyClassName';
import styles from './styles.module.scss';

const BodyWith = ({ needViewPort = false }) => {
  useBodyClassName(needViewPort ? styles.body : styles.desktop);

  React.useEffect(() => {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      `${scrollbarWidth}px`,
    );
  }, []);

  return null;
};

export default BodyWith;
